module.exports = __webpack_public_path__ + "static/media/wiper-blades-red.13c4c5b8.svg";